module.exports = "<div *ngIf=\"(alert | async).showSnackbar\" id=\"snackbar\" [ngClass]=\"(alert | async).colorClass\">\n  {{(alert | async).msg}}\n  <span class=\"snackbar-close\" (click)=\"close()\">x</span>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/com/snackbar/snackbar.com.html
// module id = ./src/app/com/snackbar/snackbar.com.html
// module chunks = main